import { useWorkflow } from '../WorkflowContext';

export default function AuditLog() {
  const wf = useWorkflow();

  return (
    <>
      <div className="page-head">
        <div>
          <div className="page-title">Sync + Audit Log</div>
          <div className="page-sub">The evidence layer showing automation, AI, task, calendar, and CRM updates.</div>
        </div>
        <div className="global-actions">
          <button className="btn small" onClick={() => wf.addAudit('Manual audit test', 'User added a manual test audit record for demonstration.')}>Add Test Audit</button>
        </div>
      </div>

      <div className="card">
        <div className="card-header"><div><h3>Audit Trail</h3><p>Every important action writes an evidence trail.</p></div></div>
        <div className="card-body">
          {wf.audit.map((i, idx) => (
            <div className="sync-row" key={idx}>
              <div className="sync-dot" />
              <div><strong>{i.title}</strong><p>{i.detail}</p></div>
              <time>{i.time}</time>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
